import { App, ColorPicker, Form, Input, Modal, Radio, Spin } from 'antd'
import { forwardRef, useImperativeHandle, useState } from 'react'
import { createTag, updateTag } from '../../../common/request'
import ResponseCode from '../../../common/response-code'
import { getUid } from '../../../plugins/utils'

const CreateTagItemModal = forwardRef((props, ref) => {
  const { model, notification } = App.useApp()
  const [form] = Form.useForm()
  const [modalVisible, setModalVisible] = useState(false)
  const [modalType, setModalType] = useState('create')
  const [loading, setLoading] = useState(false)
  useImperativeHandle(ref, () => {
    return {
      showModal
    }
  })

  const showModal = (type, row) => {
    setModalVisible(true)
    setModalType(type)
    if (type === 'edit') {
      form.setFieldsValue(row)
    }
  }

  const hideModal = () => {
    setModalVisible(false)
    form.setFieldsValue({
      name: '',
      color: '#1677ff',
      status: 1,
      id: undefined
    })
  }

  const getModalTitle = (type) => {
    if (type === 'create') {
      return '新增标签'
    } else {
      return '编辑标签'
    }
  }

  const getRequest = (values) => {
    let color = values.color
    if (typeof values.color !== 'string') {
      color = values.color.toHexString()
    }

    if (modalType === 'create') {
      return createTag({
        ...values,
        color: color,
        orgId: props.orgItem.id,
        status: 1,
        id: getUid()
      })
    } else {
      return updateTag({
        ...values,
        color: color,
        orgId: props.orgItem.id,
      })
    }
  }

  const onOk = () => {
    form.validateFields().then(values => {
      setLoading(true)
      getRequest(values).then((res) => {
        if (res.code === ResponseCode.success) {
          hideModal()
          notification.success({
            message: '操作成功',
            description: `${ modalType === 'create' ? '新增' : '更新' }标签成功`
          })
          props.insertSuccess?.()
        }
      }).catch(err => {
        console.error(err)
        model.error({
          title: '错误',
          content: '网络错误，新增标签失败'
        })
      }).finally(() => {
        setLoading(false)
      })
    })
  }

  return (
    <Modal
      width={ 500 }
      title={ getModalTitle(modalType) }
      open={ modalVisible }
      confirmLoading={ loading }
      onOk={ onOk }
      onCancel={ hideModal }
    >
      <Spin spinning={ loading }>
        <div className="my-4">
          <Form
            form={ form }
            initialValues={ {
              name: '',
              color: '#1677ff',
              status: 1,
              id: undefined
            } }
            wrapperCol={{ span: 8 }}
            labelCol={{ span: 10 }}
          >
            <Form.Item
              noStyle
              name={ 'id' }
            ></Form.Item>
            <Form.Item
              label={ '标签名称' }
              name={ 'name' }
              rules={ [
                {
                  required: true,
                  message: '请输入标签名称'
                }
              ] }
            >
              <Input placeholder={ '请输入标签名称' }></Input>
            </Form.Item>
            <Form.Item
              label={ '标签颜色' }
              name={ 'color' }
              rules={ [
                {
                  required: true,
                  message: '请输入标签内容'
                }
              ] }
            >
              <ColorPicker/>
            </Form.Item>
            <Form.Item
              label={ '标签状态' }
              name={ 'status' }
            >
              <Radio.Group options={[{ label: '禁用', value: 0 }, { label: '启用', value: 1 }]}>
              </Radio.Group>
            </Form.Item>
          </Form>
        </div>

      </Spin>
    </Modal>
  )
})

export default CreateTagItemModal
